import { jsonp } from '../../../base/base/index';
import { getUserid, getSid } from '../../../utils/callNewApp';

// 红包探针统计
export const tongji = async function tongji(value) {
    const { href } = window.location;

    return await jsonp('http://stadig.ifeng.com/actsta.js', {
        data: {
            datatype: 'wap_act',
            value,
            uri: href,
            ref: href,
            uid: getUserid(),
            sid: getSid(),
            time: new Date().getTime(),
            ci: '/',
            pt: '',
        },
        cache: false,
    });
};
